export class RestoreAzureInstanceDiskInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerDiskId",
            "baseName": "providerDiskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "AzureDiskSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureInstanceDiskInput.attributeTypeMap;
    }
    constructor() {
    }
}
